import { TipoLogin } from 'helpers/enums/TipoLogin';
import { toCapitalize } from 'helpers/utils/StringUtils';
import { IAuthUserPerfil } from './auth/IAuthUserPerfil';
import {
  AuthActionTypes,
  AUTH_ACTIONS_LOADING,
  AUTH_ACTIONS_LOGIN,
  AUTH_ACTIONS_LOGOUT,
  AUTH_ACTIONS_REGISTER_REDIRECT_PATH,
} from './AuthActionTypes';

export interface IAuthByToken {
  coops: string[];
  perfil: string;
  ldap: string;
  nome: string;
  tokenWs: string;
}

export interface IAuthUserReducer {
  nome: string;
  cpfCnpj: string;
  perfil: IAuthUserPerfil;
  coops?: string[];
  ldapAccessToken?: string;
  ldap?: string;
  associadoAccessToken?: string;
  tipoLogin?: TipoLogin;
  tokenWs?: string;
}

export interface IAuthReducer {
  logged: boolean;
  loadingUsuario: boolean;
  usuario?: IAuthUserReducer;
  redirectPath?: string;
}

const INITIAL_STATE: IAuthReducer = {
  logged: false,
  loadingUsuario: false,
};

const getNormalizedUsuario = (
  usuario?: IAuthUserReducer
): IAuthUserReducer | undefined => {
  if (usuario) {
    return {
      ...usuario,
      nome: toCapitalize(usuario.nome, true),
    };
  }
  return usuario;
};

export default function AuthReducer(
  state: IAuthReducer = INITIAL_STATE,
  action: AuthActionTypes
) {
  switch (action.type) {
    case AUTH_ACTIONS_REGISTER_REDIRECT_PATH:
      return { ...state, redirectPath: action.payload };
    case AUTH_ACTIONS_LOGIN:
      return {
        ...state,
        usuario: getNormalizedUsuario(action.payload),
        logged: true,
        loadingUsuario: false,
      };
    case AUTH_ACTIONS_LOADING:
      return {
        ...state,
        loadingUsuario: action.payload,
      };
    case AUTH_ACTIONS_LOGOUT:
      return {
        ...state,
        usuario: undefined,
        logged: false,
        redirectPath: undefined,
      };
    default:
      return { ...state };
  }
}
